<template>
    <div class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Имя</span>
            <span class="w-2/3">{{ entity.name }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Телефон</span>
            <span class="w-2/3">{{ entity.phone }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Аватар</span>
            <span class="w-2/3"><CImg
                :src="pictureUrl(entity.photo)"
                class="m2"
                width="200" /></span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Описание</span>
            <span class="w-2/3">{{ entity.description }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">ID в системе чаевых (чай-чай)</span>
            <span class="w-2/3">{{ entity.tips_layout_id }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">ID в системе чаевых (нетмонет)</span>
            <span class="w-2/3">{{ entity.tips_layout_id_new }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Активен</span>
            <span class="w-2/3">
                <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                    {{ entity.enabled ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            entity: {
                type: Object,
                default: () => {},
            },
        },

        methods: {
            pictureUrl(picture) {
                return picture ? (process.env.VUE_APP_STATIC_BASE_URL + '/' + picture) : '';
            },
        },
    };
</script>
